export const stageSettings = {
  type: 'loop',
  gap: 1,
  pagination: false,
  drag: true,
  arrows: false,
  perPage: 1,
  perMove: 1,
  start: 0,
  mediaQuery: 'min',
  easing: 'cubic-bezier(.33, 1, .68, 1)',
};
